// 格式化工具：金額（台幣 / 千分位）+ 日期（ISO UTC → 台北時區友善）

const TPE_OFFSET_MS = 8 * 60 * 60 * 1000;

/** 1200 → "NT$ 1,200" */
export function formatAmount(n: number): string {
  return `NT$ ${n.toLocaleString('en-US')}`;
}

/** ISO-8601 UTC → "2026/05/16"（TPE 當地日期） */
export function formatDateTPE(iso: string | null | undefined): string {
  if (!iso) return '—';
  const tpe = new Date(new Date(iso).getTime() + TPE_OFFSET_MS);
  const yyyy = tpe.getUTCFullYear();
  const mm = String(tpe.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(tpe.getUTCDate()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd}`;
}

/** ISO-8601 UTC → "2026/05/16 14:32"（TPE 當地時間） */
export function formatDateTimeTPE(iso: string | null | undefined): string {
  if (!iso) return '—';
  const tpe = new Date(new Date(iso).getTime() + TPE_OFFSET_MS);
  const yyyy = tpe.getUTCFullYear();
  const mm = String(tpe.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(tpe.getUTCDate()).padStart(2, '0');
  const hh = String(tpe.getUTCHours()).padStart(2, '0');
  const min = String(tpe.getUTCMinutes()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd} ${hh}:${min}`;
}

/** 中文化的訂單狀態標籤。 */
export const STATUS_LABEL: Record<string, string> = {
  pending: '待付款',
  paid: '已付款',
  closed: '已關閉',
  expired: '已過期',
  failed: '失敗',
};

/** 流程類型標籤（A / B 對應使用情境）。 */
export const FLOW_LABEL: Record<string, string> = {
  A: 'API 取號',
  B: 'UPP 連結',
};
